import { render, staticRenderFns } from "./Overrides.vue?vue&type=template&id=186f4ea6&"
import script from "./Overrides.vue?vue&type=script&lang=js&"
export * from "./Overrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports